export default __webpack_public_path__ + "static/media/Best-Cell.7e1708f1.jpg";